import { motion } from "framer-motion";
import {
  BoltIcon,
  CubeIcon,
  WrenchScrewdriverIcon,
  VideoCameraIcon,
  GlobeAsiaAustraliaIcon,
  TrophyIcon,
  UsersIcon,
  CurrencyDollarIcon,
  BuildingLibraryIcon
} from "@heroicons/react/24/solid";
import navLogo from "../../assests/navLogo.png";

export default function FirstSection({onNodeClick, onThirdSectionClick}) {


const handleNodeClick = (node) => {
  if (node.tab === "communities") {
    onThirdSectionClick();
  } else {
    onNodeClick(node.tab);
  }
};

  return (
    <section className="relative flex flex-col items-center justify-center py-8 md:py-24 overflow-hidden">
      {/* Center Core */}
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.6 }}
        className="z-10 flex flex-col items-center text-center px-4"
      >
        {/* Mobile Rows */}
        
        {/* Logo */}
        <div className="w-56 h-28 md:w-80 md:h-32 rounded-3xl flex items-center justify-center mt-6 md:mt-0">
          <img src={navLogo} alt="NextLoop" className="max-h-full object-contain" />
        </div>

        {/* Slogan */}
        <p className="mt-[-10px] text-sm md:text-base text-gray-500 font-medium">
          Handshakes Made Simple
        </p>

        {/* Title */}
        <h1 className="mt-4 md:mt-8 text-2xl md:text-4xl font-bold text-center text-gray-900">
          9 NextLoop Divisions. One Ecosystem
        </h1>

        {/* Description */}
        <p className="mt-2 md:mt-4 max-w-2xl text-center text-gray-600 text-sm md:text-base">
          NextLoop connects people, ideas, and opportunities through a living
          ecosystem of products, services, and communities.
        </p>
        
      </motion.div>
      {/* Mobile Grid */}
{/* Mobile Grid */}
<div className="lg:hidden mt-8 grid grid-cols-3 gap-y-8 gap-x-6 px-6">
  {nodes.map((node, i) => (
    <Node
      key={node.title}
      node={node}
      delay={0.1 + i * 0.05}
      onClick={() => handleNodeClick(node)}
    />
  ))}
</div>



      {/* Nodes Container (Desktop / md radial layout) */}
      <div className="hidden lg:block absolute inset-0 flex items-center justify-center z-0">
        <div className="relative w-full h-[450px]">
          {nodes.map((node, i) => {
            // Decide which positions to use based on breakpoint
            const top = node.mdTop || node.top;
            const left = node.mdLeft || node.left;

            return (
              <motion.div
                key={node.title}
                initial={{ opacity: 0, scale: 0.6 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.2 + i * 0.1 }}
                className="absolute flex flex-col items-center text-center"
                style={{ top, left }}
                onClick={() => handleNodeClick(node)}
              >
                <div
                  className={`w-16 h-16 rounded-2xl flex items-center justify-center shadow-lg ${node.bg}`}
                >
                  <node.icon className="w-8 h-8 text-white" />
                </div>
                <span className="mt-2 text-sm font-medium">{node.title}</span>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}


/* --------------------------- NODE COMPONENT --------------------------- */
function Node({ node, delay, onClick }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay }}
      onClick={onClick}
      className="flex flex-col items-center text-center"
    >
      <div
        className={`w-14 h-14 rounded-2xl flex items-center justify-center shadow-md ${node.bg}`}
      >
        <node.icon className="w-7 h-7 text-white" />
      </div>
      <span className="mt-2 text-sm font-medium">{node.title}</span>
    </motion.div>
  );
}

/* --------------------------- DATA --------------------------- */
const nodes = [
  {
    title: "NextLoop App",
    tab: "nextloop",
    bg: "bg-yellow-400",
    icon: BoltIcon,
    top: "10%",
    left: "30%",
    mdTop: "10%",
    mdLeft: "22%",
  },
  {
    title: "Services",
    tab: "services",
    bg: "bg-sky-400",
    icon: CubeIcon,
    top: "75%",
    left: "18%",
    mdTop: "75%",
    mdLeft: "20%",
  },
  {
    title: "FieldPro",
    tab: "fieldpro",
    bg: "bg-orange-500",
    icon: WrenchScrewdriverIcon,
    top: "20%",
    left: "70%",
    mdTop: "10%",
    mdLeft: "68%",
  },
  {
    title: "Spotlight",
    tab: "spotlight",
    bg: "bg-emerald-500",
    icon: VideoCameraIcon,
    top: "75%",
    left: "75%",
    mdTop: "80%",
    mdLeft: "75%",
  },
  {
    title: "Gateway",
    tab: "gateway",
    bg: "bg-indigo-500",
    icon: GlobeAsiaAustraliaIcon,
    top: "40%",
    left: "15%",
    mdTop: "25%",
    mdLeft: "7%",
  },
  {
    title: "Pickleball",
    tab: "Pickleball",
    bg: "bg-pink-500",
    icon: TrophyIcon,
    top: "40%",
    left: "80%",
    mdTop: "50%",
    mdLeft: "82%",
  },
  {
    title: "Loophole Studio",
    tab: "loophole",
    bg: "bg-purple-600",
    icon: BuildingLibraryIcon,
    top: "55%",
    left: "25%",
    mdTop: "58%",
    mdLeft: "8%",
  },
  {
    title: "Communities",
    tab: "communities",
    bg: "bg-slate-600",
    icon: UsersIcon,
    top: "30%",
    left: "85%",
    mdTop: "25%",
    mdLeft: "90%",
  },
  {
    title: "Capital",
    tab: "capital",
    bg: "bg-amber-500",
    icon: CurrencyDollarIcon,
    top: "65%",
    left: "50%",
    mdTop: "83%",
    mdLeft: "90%",
  },
];
